module.exports = __webpack_public_path__ + "static/amy-bulone-3221eb5e5a191b493467d9ff5b8ec1b8.jpg";